import React, { createContext, useState } from "react";

export const AutomationSection = createContext();

const AutomationContextProvider = (props) => {
  const [automationPage, setAutomationPage] = useState({
    firstPage: true,
    ifPage: false,
    elsePage: false,
    listPage: false,
  });

  const AutomationShowHideFunc = (page) => {
    switch (page) {
      case "firstPage":
        setAutomationPage({
          firstPage: true,
          ifPage: false,
          elsePage: false,
          listPage: false,
        });
        break;
      case "ifPage":
        setAutomationPage({
          firstPage: false,
          ifPage: true,
          elsePage: false,
          listPage: false,
        });
        break;
      case "elsePage":
        setAutomationPage({
          firstPage: false,
          ifPage: false,
          elsePage: true,
          listPage: false,
        });
        break;
      case "listPage":
        setAutomationPage({
          firstPage: false,
          ifPage: false,
          elsePage: false,
          listPage: true,
        });

        break;
      case "noPage":
        setAutomationPage({
          firstPage: false,
          ifPage: false,
          elsePage: false,
          listPage: false,
        });

        break;
    }
  };

  return (
    <>
      <AutomationSection.Provider
        value={{ automationPage, AutomationShowHideFunc }}
      >
        {props.children}
      </AutomationSection.Provider>
    </>
  );
};

export { AutomationContextProvider };
